import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useAppSelector, useAppDispatch } from '../hooks';
import { Dialog } from '../components/DialogOld';
import { createPanelGroup } from '../actions/CreatePanelGroup';
import { savePanelGroup } from '../actions/SavePanelGroup';
import { deletePanelGroup } from '../actions/DeletePanelGroup';
import { updateEditPanelGroupDialogOrd, updateEditPanelGroupDialogTitle } from '../reducers/edit_panel_group_dialog';
import { FormGroup } from '../components/FormGroup';
import { FormRow } from '../components/FormRow';
import { hideDialog } from '../reducers/app';
const DeleteButton = (props) => (_jsx("button", { type: "button", className: "delete lw danger", onClick: props.onClick, children: "Ta bort" }, "delete"));
const CancelButton = (props) => (_jsx("button", { type: "button", className: "lw", onClick: props.onClick, children: "Avbryt" }, "cancel"));
const SaveButton = (props) => (_jsx("button", { type: "button", className: "save lw primary", onClick: props.onClick, children: "Spara \u00E4ndringar" }, "save"));
const CreateButton = (props) => (_jsx("button", { type: "button", className: "save lw primary", onClick: props.onClick, children: "Skapa grupp" }, "create"));
export const DialogPanelGroupEdit = (props) => {
    const dispatch = useAppDispatch();
    const dialog = useAppSelector(state => state.edit_panel_group_dialog);
    let footerleft, footerright;
    const id = dialog.id == null ? '' : dialog.id;
    if (id) {
        footerleft = [
            (_jsx(DeleteButton, { onClick: () => dispatch(deletePanelGroup()) }, "delete"))
        ];
        footerright = [
            (_jsx(CancelButton, { onClick: () => dispatch(hideDialog()) }, "cancel")),
            (_jsx(SaveButton, { onClick: () => dispatch(savePanelGroup()) }, "save"))
        ];
    }
    else {
        footerright = [
            (_jsx(CancelButton, { onClick: () => dispatch(hideDialog()) }, "cancel")),
            (_jsx(CreateButton, { onClick: () => dispatch(createPanelGroup()) }, "create"))
        ];
    }
    return (_jsxs(Dialog, { id: "group-edit", title: "Redigera grupp", footerleft: footerleft, footerright: footerright, children: [_jsxs(FormRow, { children: [_jsx("input", { name: "group_id", type: "hidden", value: id }), _jsx("input", { name: "panel_id", type: "hidden", value: props.panel_id }), _jsx(FormGroup, { label: "Namn", children: _jsx("input", { type: "text", name: "title", value: dialog.title, onChange: event => dispatch(updateEditPanelGroupDialogTitle(event.target.value)) }) })] }), _jsx(FormRow, { children: _jsx(FormGroup, { label: "Ordning", children: _jsx("input", { type: "text", name: "ord", value: isNaN(dialog.ord) ? '' : dialog.ord, onChange: event => dispatch(updateEditPanelGroupDialogOrd(parseInt(event.target.value))) }) }) })] }));
};
